module.exports = __webpack_public_path__ + "static/media/Gaurav Rahangdale_Web developer_.0033c055.pdf";